module.exports = __webpack_public_path__ + "static/contact__hero.3db1bb4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact__hero.jpg
// module id = 490
// module chunks = 70144966829960